export default __webpack_public_path__ + "static/media/close-orange.2ac32659.svg";